(function() {
'use strict';

const TR = angular.module('TR');
TR.directive('seatSelection', function(resourceService, customCurrencyFilter, scrollService, $timeout) {
    return {
        restrict: 'E',
        scope: {
            flightSeatPlan: '=',
            getSelectedSeats: '&',
            selectSeats: '&',
            closePlan: '&',
            totalPrice: '='
        },
        templateUrl: 'partials/holidays/seatselection',
        link(scope) {
            let seatToConfirm = null;

            const cancel = scope.$watch('flightSeatPlan', function(val) {
                if (val == null) {
                    return;
                }

                scope.flights = val.Segments.Outbound.concat(val.Segments.Inbound || []);
                scope.selectedFlight = val.Segments.Outbound[0];
                scope.passengers = val.Passengers;
                scope.selectedPassenger = val.Passengers[0];
                scope.showSafetyMsg = false;
                generatePlanRows();
                restoreSelectedSeats();
                cycleNextPassenger();
                cancel();
            });

            scope.$watch('totalPrice', function(price, oldPrice) {
                if (price === 0 && oldPrice > 0) {
                    // the seats have been removed
                    scope.selectSeats({ seats: [] });
                    scope.changeSeats();
                }
            });

            function restoreSelectedSeats() {
                // Seats should be in the format 'Seat::Adult 1 2A,3A'
                scope.getSelectedSeats().forEach(selectedSeat => {
                    const tokens = selectedSeat.OptionId.split(' ');
                    const isChild = tokens[0] === 'Seat::Child';
                    const sequence = +tokens[1];
                    const passenger = scope.passengers
                        .filter(p => p.IsChild === isChild && p.Sequence === sequence)[0];

                    tokens[2].split(',').forEach((seatNumber, i) => {
                        const flight = scope.flights[i];
                        const seat = findSeatInFlight(flight, seatNumber);
                        confirmSeat(passenger, flight, seat);
                    });
                });
                scope.totalPrice = scope.getTotalPrice();
            }

            function findSeatInFlight(flight, seatNumber) {
                for (const row of flight.SeatPlan.Rows) {
                    for (const block of row.Blocks) {
                        for (const seat of block.Seats) {
                            if (seat.Number === seatNumber) {
                                return seat;
                            }
                        }
                    }
                }
            }

            function saveSelectedSeats() {
                scope.selectSeats({
                    seats: scope.passengers.map(p => {
                        const type = p.HasInfant === true ? 'Adult-with-Infant' : p.Description;
                        const seats = p.Seats.map(s => s.Number);
                        return {
                            OptionId: `Seat::${type} ${p.Sequence} ${seats.join()}`,
                            Quantity: 1
                        };
                    }),
                    seatsPostAdd: _.flatMap(scope.passengers, p =>
                        p.Seats.map(seat => ({
                                SeatNumber: seat.Number,
                                PassengerID: p.Id,
                                LegId: seat.LegId,
                                SegmentHash: seat.Segement,
                                IncludesInfant: p.HasInfant
                            })
                        ))
                    });
                scope.totalPrice = scope.getTotalPrice();
            }

            scope.canConfirm = function() {
                if (!scope.flightSeatPlan) {
                    return false;
                }

                for (const p of scope.flightSeatPlan.Passengers) {
                    for (const s of p.Seats) {
                        if (!s.Number) {
                            return false;
                        }
                    }
                }

                return true;
            };

            scope.confirm = function() {
                saveSelectedSeats();
                scope.closePlan();
            };

            scope.getFlightSegmentType = function(flight) {
                if (scope.flightSeatPlan.Segments.Outbound.indexOf(flight) !== -1) {
                    return 'out';
                }

                return 'in';
            };

            scope.selectFlight = function(flight) {
                if (scope.selectedFlight !== flight) {
                    scope.selectedFlight = flight;
                    scope.selectedPassenger = scope.passengers[0];
                    generatePlanRows();
                }
            };

            scope.selectPassenger = function(flight, passenger) {
                if (scope.selectedFlight !== flight) {
                    scope.selectedFlight = flight;
                    generatePlanRows();
                }
                scope.selectedPassenger = passenger;
            };

            scope.getSelectedPassengerIndex = function() {
                return _.findIndex(scope.passengers, scope.selectedPassenger);
            };

            function getFlightIndex(flight) {
                return scope.flights.indexOf(flight);
            }

            scope.getPassengerSeatForFlight = function(passenger, flight) {
                return passenger.Seats[getFlightIndex(flight)];
            };

            scope.getTotalPrice = function() {
                return scope.flightSeatPlan && _.chain(scope.flightSeatPlan.Passengers)
                    .flatMap(p => p.Seats)
                    .sumBy('Price')
                    .round(2)
                    .value();
            };

            function getRowPrices(seats) {
                let rowAdultMinPrice = 0;
                let rowAdultMaxPrice = 0;
                let rowChildMinPrice = 0;
                let rowChildMaxPrice = 0;
                let rowAdultWithInfantMinPrice = 0;
                let rowAdultWithInfantMaxPrice = 0;

                for (const s of seats) {
                    if (!s || !s.IsAvailable) {
                        continue;
                    }
                    const {
                        AdultPrice,
                        ChildPrice,
                        AdultWithInfantPrice,
                        AvailableForChild,
                        AvailableForInfant } = s;
                    if (rowAdultMaxPrice < AdultPrice) {
                        rowAdultMaxPrice = AdultPrice;
                    }
                    if (rowChildMaxPrice < ChildPrice) {
                        rowChildMaxPrice = ChildPrice;
                    }
                    if (rowAdultWithInfantMaxPrice < AdultWithInfantPrice) {
                        rowAdultWithInfantMaxPrice = AdultWithInfantPrice;
                    }
                    if (!rowAdultMinPrice || rowAdultMinPrice > AdultPrice) {
                        rowAdultMinPrice = AdultPrice;
                    }
                    if (AvailableForChild && (!rowChildMinPrice || rowChildMinPrice > ChildPrice)) {
                        rowChildMinPrice = ChildPrice;
                    }
                    if (AvailableForInfant && (!rowAdultWithInfantMinPrice || rowAdultWithInfantMinPrice > AdultWithInfantPrice)) {
                        rowAdultWithInfantMinPrice = AdultWithInfantPrice;
                    }
                }

                return {
                    rowAdultMinPrice,
                    rowAdultMaxPrice,
                    rowChildMinPrice,
                    rowChildMaxPrice,
                    rowAdultWithInfantMinPrice,
                    rowAdultWithInfantMaxPrice
                };
            }

            function blocksToCols(blocks) {
                return blocks.reduce((cols, block) => {
                    if (cols.length) {
                        cols.push(null);
                    }
                    return cols.concat(block.Seats);
                }, []);
            }

            function generatePlanRows() {
                const rows = [];

                const headerCols = blocksToCols(scope.selectedFlight.SeatPlan.HeaderRow.Blocks);
                const headers = headerCols.map(h => h && h.Number);

                rows.push({
                    type: 'head',
                    cols: headerCols
                });

                let groupAdultMinPrice = 0;
                let groupAdultMaxPrice = 0;
                let groupChildMinPrice = 0;
                let groupChildMaxPrice = 0;
                let groupAdultWithInfantMinPrice = 0;
                let groupAdultWithInfantMaxPrice = 0;
                scope.selectedFlight.SeatPlan.Rows.forEach(row => {
                    const cols = blocksToCols(row.Blocks);

                    const {
                        rowAdultMinPrice,
                        rowAdultMaxPrice,
                        rowChildMinPrice,
                        rowChildMaxPrice,
                        rowAdultWithInfantMinPrice,
                        rowAdultWithInfantMaxPrice } = getRowPrices(cols);
                    if (rowAdultMinPrice !== groupAdultMinPrice
                        || rowAdultMaxPrice !== groupAdultMaxPrice
                        || rowChildMinPrice !== groupChildMinPrice
                        || rowChildMaxPrice !== groupChildMaxPrice
                        || rowAdultWithInfantMinPrice !== groupAdultWithInfantMinPrice
                        || rowAdultWithInfantMaxPrice !== groupAdultWithInfantMaxPrice) {
                        groupAdultMinPrice = rowAdultMinPrice;
                        groupAdultMaxPrice = rowAdultMaxPrice;
                        groupChildMinPrice = rowChildMinPrice;
                        groupChildMaxPrice = rowChildMaxPrice;
                        groupAdultWithInfantMinPrice = rowAdultWithInfantMinPrice;
                        groupAdultWithInfantMaxPrice = rowAdultWithInfantMaxPrice;

                        rows.push({
                            type: 'group',
                            cols: [{
                                AdultMinPrice: rowAdultMinPrice,
                                AdultMaxPrice: rowAdultMaxPrice,
                                ChildMinPrice: rowChildMinPrice,
                                ChildMaxPrice: rowChildMaxPrice,
                                AdultWithInfantMinPrice: rowAdultWithInfantMinPrice,
                                AdultWithInfantMaxPrice: rowAdultWithInfantMaxPrice
                            }]
                        });
                    }

                    rows.push({
                        type: 'seats',
                        label: cols[0].Number.match(/\d+/)[0],
                        cols: headers.map(h => {
                            if (!h) {
                                return 'label';
                            }

                            for (let i = 0; i < cols.length; i++) {
                                const col = cols[i];
                                if (col && h === col.Number.match(/[a-z]+/i)[0]) {
                                    return col;
                                }
                            }

                            return null;
                        })
                    });
                });

                scope.planColspan = headerCols.length;
                scope.planRows = rows;
            }

            function isSeatAvailable(seat) {
                if (!seat.IsAvailable) {
                    return false;
                }

                if (scope.selectedPassenger.IsChild && !seat.AvailableForChild) {
                    return false;
                }

                if (scope.selectedPassenger.HasInfant && !seat.AvailableForInfant) {
                    return false;
                }

                const i = getFlightIndex(scope.selectedFlight);
                for (const p of scope.flightSeatPlan.Passengers) {
                    if (p.Seats[i].Number === seat.Number && p !== scope.selectedPassenger) {
                        return false;
                    }
                }

                return true;
            }

            scope.getSeatClass = function(seat) {
                const i = getFlightIndex(scope.selectedFlight);

                let isSelected = false;
                for (const p of scope.passengers) {
                    if (p.Seats[i].Number === seat.Number) {
                        isSelected = true;
                        break;
                    }
                }

                return {
                    selected: isSelected,
                    restricted: !!seat.RestrictionTextId,
                    unavailable: !isSeatAvailable(seat),
                    xl: seat.HasExtraLegRoom
                };
            };

            function getSeatMessage(Id) {
                for (const m of scope.selectedFlight.SeatPlan.SeatMessages) {
                    if (m.Id === Id) {
                        return m.Information;
                    }
                }
            }

            scope.getSeatTip = function(seat) {
                if (isSeatAvailable(seat)) {
                    return getSeatMessage(seat.AdditionalInfoTextId);
                }
            };

            function confirmSeat(passenger, flight, seat) {
                const selectedSeat = scope.getPassengerSeatForFlight(passenger, flight);
                selectedSeat.Number = seat.Number;

                if (scope.selectedPassenger.IsChild) {
                    selectedSeat.Price = seat.ChildPrice;
                } else if (scope.selectedPassenger.HasInfant) {
                    selectedSeat.Price = seat.AdultWithInfantPrice;
                } else {
                    selectedSeat.Price = seat.AdultPrice;
                }
            }

            function cycleNextPassenger(wait = false) {
                $timeout(() => {
                    for (let i = 0; i < scope.flights.length; i++) {
                        for (const p of scope.passengers) {
                            if (!p.Seats[i].Number) {
                                scope.selectPassenger(scope.flights[i], p);
                                return;
                            }
                        }
                        scope.selectedFlight === scope.flights[i] && $('.body-content-inner-wrapper').scrollTop(0);
                    }
                    scope.allSeatsSelected = true;
                }, wait && 700);
            }

            scope.setPassengerSeat = function(seat, wait) {
                if (!isSeatAvailable(seat)) {
                    return;
                }

                const selectedSeat = scope.getPassengerSeatForFlight(scope.selectedPassenger, scope.selectedFlight);
                seatToConfirm = null;
                if (selectedSeat.Number === seat.Number) {
                    // de-select the seat
                    selectedSeat.Number = null;
                    selectedSeat.Price = 0;
                } else if (seat.RestrictionTextId) {
                    seatToConfirm = seat;
                    scope.restrictionText = getSeatMessage(seat.RestrictionTextId);
                    scope.showSafetyMsg = true;
                } else {
                    confirmSeat(scope.selectedPassenger, scope.selectedFlight, seat);
                    cycleNextPassenger(wait);
                }
            };

            scope.confirmRestrictedSeat = function() {
                confirmSeat(scope.selectedPassenger, scope.selectedFlight, seatToConfirm);
                cycleNextPassenger();
                scope.closeRestrictionSeat();
            };

            scope.closeRestrictionSeat = function() {
                seatToConfirm = null;
                scope.showSafetyMsg = false;
            };

            scope.addPassengerSelectionText = function(passenger, index) {
                const pType = resourceService.get(passenger.HasInfant
                    ? 'ADULTWITHINFANT'
                    : !passenger.IsChild && !passenger.HasInfant
                        ? 'ADULT'
                        : 'CHILD');
                const { Number, Price } = scope.getPassengerSeatForFlight(passenger, scope.selectedFlight);

                passenger.description = `${pType} ${parseInt(index) + 1}`;
                passenger.selectionText = passenger.description +
                        (Number ? `, ${Number}` : '') +
                        (Price ? `, ${customCurrencyFilter(Price)}` : '');
                passenger.selection = {
                    Number,
                    Price: Price && customCurrencyFilter(Price) || ''
                };
                return passenger;
            };

            scope.getPassengersGrouped = function() {
                return _.chain(scope.passengers)
                    .reject(['Type', 3])
                    .groupBy('Type')
                    .flatMap(group => group.map(scope.addPassengerSelectionText))
                    .value();
            };

            scope.changeSeats = function() {
                scope.passengers.forEach(p => p.Seats.forEach(s => {
                    s.Number = null;
                    s.Price = null;
                }));
                scope.selectedFlight = scope.flights[0];
                scope.selectedPassenger = scope.passengers[0];
                scope.allSeatsSelected = false;
            };


            scope.showRestrictionText = function(row) {
                return seatToConfirm && seatToConfirm.Number
                    && row.cols && row.cols.some(c => c && c.Number === seatToConfirm.Number);
            };
        }
    };
});
})();
